'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimatedSmallLoader = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function AnimatedSmallLoader(_ref) {
  var sizeModifier = _ref.sizeModifier;
  var concatenatedClassName = 'animated-loader animated-loader__button ' + sizeModifier;
  return _react2['default'].createElement('div', {
    className: concatenatedClassName
  });
}

AnimatedSmallLoader.propTypes = {
  sizeModifier: _propTypes2['default'].string
};
exports.AnimatedSmallLoader = AnimatedSmallLoader;